import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Energy.css";
import NavbaR from "../Navbar/NavbaR";
import {BsDot} from 'react-icons/bs';

function Energy() {
  return (
    <div className="strategy-main">
    <div className="energy-top-div">
      <div><NavbaR/></div>
      <h1 className="strategy-label">Energy</h1>
    </div>

    <div className="strategy-evaluation-main">
      <h3 className="strategy-evaluation-title">Special Situations Investment Company</h3>
      <div className="title-placer" style={{width:'16rem'}}>&nbsp;</div>
      <p className="evaluation-details"  id='evaluation-details-id'>Eram Capital Partners collaborates with small to medium size private and public enterprises operating in the Conventional and Renewable energy sectors ((onshore and offshore) in United Kingdom, Europe and North America. Eram develops opportunities for partnership and investment with companies who have expertise and growth prospects in the following industries:
      </p>
    </div>

    <div className="evaluation-points-main">
      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">		Energy production:</p>
      </div>

      <div style={{paddingLeft:'3rem'}}>

      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">		Gas and coal fired-power plants</p>
      </div>
      
      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">		Solar, wind, and biomass power plants</p>
      </div>
      
      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">			Alternative energy production through chemical processes</p>
      </div>

      </div>

      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">		Energy exploration:</p>
      </div>

      <div style={{paddingLeft:'3rem'}}>

      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">		Conventional and unconventional gas and oil projects</p>
      </div>
      
      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">		Innovative exploration technologies</p>
      </div>

      </div>

      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">Energy storage and logistics:</p>
      </div>

      <div style={{paddingLeft:'3rem'}}>
      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">	New technologies in bulk storage</p>
      </div>

      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">	Transportation infrastructure</p>
      </div>
      </div>

      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">	Energy downstream:</p>
      </div>

      <div style={{paddingLeft:'3rem'}}>
      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">	Petrochemicals</p>
      </div>

      <div className="evaluation-point">
        <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
        <p className="evaluation-point-details">		Derivative fuel oils</p>
      </div>
      </div>

    </div>

        <p className="evaluation-details">The global economy is undergoing a significant transformation in the trend toward new technologies in Conventional Energy and the rapid adoption of Renewable Energy production techniques. Eram Capital Partners and our investor partners believe in the profound demographic factors driving growth in the global Energy sector. Some of the key factors are:</p>

        <div className="evaluation-points-main">
        <div className="evaluation-point">
          <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
          <p className="evaluation-point-details">	Rapid population growth in the developing world putting pressure on energy resources</p>
        </div>
        <div className="evaluation-point">
          <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
          <p className="evaluation-point-details">		Increased global productivity in the developed world demanding greater energy production efficiency and longevity</p>
        </div>

        <div className="evaluation-point">
          <div className="bullet-point"><BsDot style={{fontSize:'2rem'}}/></div>
          <p className="evaluation-point-details">	Governmental policies restricting conventional production and promoting unconventional and renewable production</p>
        </div>
       </div>

   
        <p className="evaluation-details">Eram Capital Partners has unique access to strategic and financial investors globally who have an abundance of capital resources and understand the global demographic trends driving the Conventional and Renewable Energy sectors. Eram Capital and its investor partners have a long history of energy sector experience in key geographies around the world.
We can provide development capital, growth capital for companies and projects for foreign expansion and can facilitate commercial partnerships globally.
    </p>

  </div>
  );
}

export default Energy;
